import * as THREE from 'three';
import {GLTFLoader} from './GLTFLoader.js';
import {OrbitControls} from './OrbitControls.js';

document.addEventListener('DOMContentLoaded', () => {
  const scene = new THREE.Scene();
  const group = new THREE.Group();
  scene.add(group);
  group.position.set(0, -1, 0);

  const camera = new THREE.PerspectiveCamera(
    60,
    window.innerWidth / window.innerHeight,
    0.1,
    100
  );
  camera.position.set(0, 0.75, -1);

  const light = new THREE.PointLight(0xffffff, 2, 100);
  light.position.set(0, 3, 0);
  scene.add(light);

  const light2 = new THREE.PointLight(0xffffff, 1, 100);
  light2.position.set(3, 0, 0);
  scene.add(light2);

  const renderer = new THREE.WebGLRenderer({});
  renderer.setSize(window.innerWidth, window.innerHeight);
  document.body.append(renderer.domElement);
  renderer.setClearColor('white');

  const loader = new GLTFLoader();
  loader.load('models/ExteriorLowRes.glb', (gltf: {scene: THREE.Group}) => {
    console.log(gltf);
    group.add(gltf.scene);
    // const obj = group.getObjectByName('MainOutside') as THREE.Group;
    // for (const child of obj.children) {
    //   if (child instanceof THREE.Mesh) {
    //     child.material = new THREE.MeshPhysicalMaterial({
    //       color: 'red',
    //     });
    //     console.log(child);
    //   }
    // }
  });

  const controls = new OrbitControls(camera, renderer.domElement);

  function onWindowResize() {
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();

    renderer.setSize(window.innerWidth, window.innerHeight);
  }
  window.addEventListener('resize', onWindowResize);

  renderer.setAnimationLoop(() => {
    renderer.render(scene, camera);
  });
});
